import SubTitle from "components/common/sub/SubTitle";

const Business8 = () => {
  const processArr = [
    {
      id: 1,
      title: "요철이 심하지 않은 평탄한 곳을 선정",
      icon: "/icons/icon1.png",
    },
    {
      id: 2,
      title: "종·횡 길이 1m이상을 표시",
      icon: "/icons/icon13.png",
    },
    {
      id: 3,
      title: "설계도면을 분석",
      icon: "/icons/icon17.png",
    },
    {
      id: 4,
      title: "철근의 배근상태를 숙지",
      icon: "/icons/icon20.png",
    },
    {
      id: 5,
      title: "종·횡방향 시작점을 표시",
      icon: "/icons/icon14.png",
    },
    {
      id: 6,
      title: "상·하부구조에 각각 1회이상 드릴링",
      icon: "/icons/icon16.png",
    },
    {
      id: 7,
      title: "속도는 1초당 40cm이하로 측정",
      icon: "/icons/icon15.png",
    },

    {
      id: 8,
      title: "실제 피복이 일치하는 Mode를 선정하여 측정",
      icon: "/icons/icon18.png",
    },
    {
      id: 9,
      title: "인접부위에서 재측정하여 원인을 분석",
      sub: "(도면과 일치하지 않거나, 파형분석이 난해한 경우)",
      icon: "/icons/icon19.png",
    },
  ];
  return (
    <div className=" relative w-full h-full">
      <SubTitle
        category="업무분야"
        title="철근탐사 (Ferroscan)"
        src="/images/sub13.jpg"
      />
      <div className=" relative w-full h-full px-[calc((100%-var(--container))/2)] py-14 lg:py-28">
        <div className=" relative w-full h-full max-w-[var(--container-width)] mx-auto">
          <div id="title">
            <h3>철근탐사 (Ferroscan)</h3>
          </div>
          <div className=" relative w-full h-full grid gap-5 my-5 lg:my-10">
            <p>
              이 시험은 콘크리트속에 매입된 철근의 배근상태(피복두께,
              철근간격)를 평가하기 위하여 실시한다.
            </p>
            <div className=" relative w-full h-96 lg:h-[550px] bg-gray-300 grid grid-cols-2 lg:grid-cols-3 grid-rows-3 lg:grid-rows-2 gap-1">
              <div className=" relative w-full h-full overflow-hidden">
                <img
                  className=" relative w-full h-full object-cover object-center"
                  src="/images/business77.jpg"
                  alt="business"
                />
              </div>
              <div className=" relative w-full h-full overflow-hidden">
                <img
                  className=" relative w-full h-full object-cover object-center"
                  src="/images/business78.jpg"
                  alt="business"
                />
              </div>
              <div className=" relative w-full h-full overflow-hidden">
                <img
                  className=" relative w-full h-full object-cover object-center"
                  src="/images/business79.jpg"
                  alt="business"
                />
              </div>
              <div className=" relative w-full h-full overflow-hidden">
                <img
                  className=" relative w-full h-full object-cover object-center"
                  src="/images/business80.jpg"
                  alt="business"
                />
              </div>
              <div className=" relative w-full h-full overflow-hidden">
                <img
                  className=" relative w-full h-full object-cover object-center"
                  src="/images/business81.jpg"
                  alt="business"
                />
              </div>
              <div className=" relative w-full h-full overflow-hidden">
                <img
                  className=" relative w-full h-full object-cover object-center"
                  src="/images/business82.jpg"
                  alt="business"
                />
              </div>
            </div>
            <h3>평가 기준</h3>
            <p>
              Output된 철근의 덮개와 간격은 설계도면과 관련 시방서와 비교하여
              평가한다.
            </p>
          </div>
        </div>
      </div>
      <div className=" relative w-full h-full bg-[var(--light-color)] px-[calc((100%-var(--container))/2)] py-14 lg:py-28">
        <div className=" relative w-full h-full max-w-[var(--container-width)] mx-auto">
          <h3>진행 프로세스</h3>
          <div className=" relative w-full h-full grid grid-cols-1 lg:grid-cols-3 grid-rows-7 lg:grid-rows-3 gap-10 mt-10">
            {processArr.map((v, i) => (
              <div
                key={i}
                className=" relative w-full h-full bg-white py-10 px-8 rounded-sm"
              >
                <div className=" absolute top-[-18px] left-3 w-fit h-fit py-1 px-5 bg-[var(--point-color)] text-white rounded-full">
                  <p className="font-black">STEP 0{v.id}</p>
                </div>
                <div className=" relative w-10 h-10 lg:w-14 lg:h-14 mb-5">
                  <img
                    className=" relative w-full h-full object-contain"
                    src={process.env.PUBLIC_URL + v.icon}
                    alt="icon"
                  />
                </div>
                <small>{v.sub}</small>
                <h4>{v.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Business8;
